














import { createComponent, watch, ref } from '@vue/composition-api'
import { operates } from '@/constant'
function modelBind(startVal, onValidate) {
    let val = ref(startVal)
    watch(val, value => {
        onValidate(value)
    })
    return {
        val,
    }
}
export default createComponent({
    props: {
        value: {
            type: Array,
            require: true,
        },
        another: String,
    },
    setup(props, { emit }) {
        const { val: checkList } = modelBind(props.value, value => emit('input', value))
        return {
            checkList,
            operates,
        }
    },
})
